export default(() => {
    const EntityType = { KEYWORD:0, FUNCTION:1 }
    return  {
        EntityType : EntityType,
        keywords :  [
            {
                name:'SELECT', 
                nl_before(){ return true; }, 
                nl_after(){ return true; }, 
                type:EntityType.KEYWORD 
            
            },
            {
                name:'DISTINCT', 
                nl_before(){ return false; }, 
                nl_after(){ return false; }, 
                type:EntityType.KEYWORD 
            
            },
            {
                name:'FROM',   
                nl_before(){ return true; }, 
                nl_after(){ return false; }, 
                type:EntityType.KEYWORD 
            
            },
            {
                name:'WHERE',  
                nl_before(){ return true; }, 
                nl_after(){ return true; }, 
                type:EntityType.KEYWORD 
            
            },
            {
                name:'UNION',  
                nl_before(){ return true; }, 
                nl_after(){ return false; }, 
                type:EntityType.KEYWORD 
            
            },
            {
                name:'INSERT', 
                nl_before (){ return true; }, 
                nl_after (){ return false; }, 
                type:EntityType.KEYWORD 
            
            },
            {
                name:'INTO',   
                nl_before (){ return false; }, 
                nl_after (){ return false; }, 
                type:EntityType.KEYWORD 
            
            },
            {
                name:'UPDATE', 
                nl_before (){ return true; }, 
                nl_after (){ return false; }, 
                type:EntityType.KEYWORD 
            
            },
            {
                name:'DELETE', 
                nl_before(){ return true; }, 
                nl_after(){ return false; }, 
                type:EntityType.KEYWORD 
            },
            {
                name:'HAVING', 
                nl_before(){ return true; }, 
                nl_after(){ return false; }, 
                type:EntityType.KEYWORD 
            },
            {
                name:'ORDER',  
                nl_before (){ return true; }, 
                nl_after(){ return false; }, 
                type:EntityType.KEYWORD 
            },
            {
                name:'GROUP',  
                nl_before (){ return true; }, 
                nl_after(){ return false; }, 
                type:EntityType.KEYWORD 
            },
            {
                name:'USE',    
                nl_before (){ return true; }, 
                nl_after(){ return false; }, 
                type:EntityType.KEYWORD 
            },
            {
                name:'BY',     
                nl_before (){ return false; }, 
                nl_after(last_kwd){ return ['GROUP', 'ORDER'].indexOf(last_kwd) >= 0; }, 
                type:EntityType.KEYWORD 
            },
            {
                name:'AND',    
                nl_before (last_kwd){ return last_kwd != 'BETWEEN'; }, 
                nl_after(){ return false; }, 
                type:EntityType.KEYWORD 
            },
            {
                name:'OR',     
                nl_before (){ return true; }, 
                nl_after(){ return false; }, 
                type:EntityType.KEYWORD 
            },
            {
                name:'DESC',     
                nl_before (){ return true; }, 
                nl_after(){ return false; }, 
                type:EntityType.KEYWORD 
            },
            {
                name:'ASC',     
                nl_before (){ return true; }, 
                nl_after(){ return false; }, 
                type:EntityType.KEYWORD 
            },
            {
                name:'INNER',  
                nl_before (){ return true; }, 
                nl_after(){ return false; }, 
                type:EntityType.KEYWORD 
            },
            {
                name:'OUTER',  
                nl_before (){ return true; }, 
                nl_after(){ return false; }, 
                type:EntityType.KEYWORD 
            },
            {
                name:'LEFT',   
                nl_before (){ return true; }, 
                nl_after(){ return false; }, 
                type:EntityType.KEYWORD 
            },
            {
                name:'RIGHT',  
                nl_before (){ return true; }, 
                nl_after(){ return false; }, 
                type:EntityType.KEYWORD 
            },
            {
                name:'JOIN',   
                nl_before (){ return false; }, 
                nl_after(){ return false; }, 
                type:EntityType.KEYWORD 
            },
            {
                name:'BETWEEN',
                nl_before (){ return false; }, 
                nl_after(){ return false; }, 
                type:EntityType.KEYWORD 
            },
            {
                name:'AS',     
                nl_before (){ return false; }, 
                nl_after(){ return false; }, 
                type:EntityType.KEYWORD 
            },
            {
                name:'ON',     
                nl_before (){ return false; }, 
                nl_after(){ return false; }, 
                type:EntityType.KEYWORD 
            },
            {
                name:'IN',     
                nl_before (){ return false; }, 
                nl_after(){ return false; }, 
                type:EntityType.KEYWORD 
            },
            {
                name:'IS',     
                nl_before (){ return false; }, 
                nl_after(){ return false; }, 
                type:EntityType.KEYWORD 
            },
            {
                name:'NOT',    
                nl_before (){ return false; }, 
                nl_after(){ return false; }, 
                type:EntityType.KEYWORD 
            },
            {
                name:'CASE',   
                nl_before (){ return true; }, 
                nl_after(){ return true; }, 
                type:EntityType.KEYWORD 
            },
            {
                name:'WHEN',   
                nl_before (){ return true; }, 
                nl_after(){ return false; }, 
                type:EntityType.KEYWORD 
            },
            {
                name:'ELSE',   
                nl_before (){ return true; }, 
                nl_after(){ return false; }, 
                type:EntityType.KEYWORD 
            },
            {
                name:'THEN',   
                nl_before (){ return false; }, 
                nl_after(){ return false; }, 
                type:EntityType.KEYWORD 
            },
            {
                name:'END',    
                nl_before (){ return true; }, 
                nl_after(){ return true; }, 
                type:EntityType.KEYWORD 
            },
            {
                name:'WITH',   
                nl_before (){ return false; }, 
                nl_after(){ return false; }, 
                type:EntityType.KEYWORD 
            },
            {
                name:'OVER',   
                nl_before (){ return false; }, 
                nl_after(){ return false; }, 
                type:EntityType.KEYWORD 
            },
            {
                name:'PIVOT',   
                nl_before (){ return true; }, 
                nl_after(){ return false; }, 
                type:EntityType.KEYWORD 
            },
            {
                name:'NULL',   
                nl_before (){ return false; }, 
                nl_after(){ return false; }, 
                type:EntityType.FUNCTION 
            },
            {
                name:'TRUE',   
                nl_before (){ return false; }, 
                nl_after(){ return false; }, 
                type:EntityType.FUNCTION 
            },
            {
                name:'FALSE',  
                nl_before (){ return false; }, 
                nl_after(){ return false; }, 
                type:EntityType.FUNCTION 
            },
            {
                name:'GETDATE',
                nl_before (){ return false; }, 
                nl_after(){ return false; }, 
                type:EntityType.FUNCTION 
            },
            {
                name:'DATEDIFF',
                nl_before (){ return false; }, 
                nl_after(){ return false; }, 
                type:EntityType.FUNCTION 
            },
            {
                name:'SUM',    
                nl_before (){ return false; }, 
                nl_after(){ return false; }, 
                type:EntityType.FUNCTION 
            },
            {
                name:'COUNT',  
                nl_before (){ return false; }, 
                nl_after(){ return false; }, 
                type:EntityType.FUNCTION 
            },
            {
                name:'MAX',    
                nl_before (){ return false; }, 
                nl_after(){ return false; }, 
                type:EntityType.FUNCTION 
            },
            {
                name:'MIN',    
                nl_before (){ return false; }, 
                nl_after(){ return false; }, 
                type:EntityType.FUNCTION 
            },
            {
                name:'CONCAT', 
                nl_before(){ return false; }, 
                nl_after(){ return false; }, 
                type:EntityType.FUNCTION 
            },
            {
                name:'CAST',   
                nl_before (){ return false; }, 
                nl_after(){ return false; }, 
                type:EntityType.FUNCTION 
            },
            {
                name:'DATE',   
                nl_before (){ return false; }, 
                nl_after(){ return false; }, 
                type:EntityType.FUNCTION 
            },
            {
                name:'ROW_NUMBER', 
                nl_before(){ return false; }, 
                nl_after(){ return false; }, 
                type:EntityType.FUNCTION 
            },
            {
                name:'COALESCE', 
                nl_before(){ return false; }, 
                nl_after(){ return false; }, 
                type:EntityType.FUNCTION 
            },
            {
                name:'ROUND', 
                nl_before(){ return false; }, 
                nl_after(){ return false; }, 
                type:EntityType.FUNCTION 
            },
            {
                name:'AVG', 
                nl_before(){ return false; }, 
                nl_after(){ return false; }, 
                type:EntityType.FUNCTION 
            }
        ]
    };

})();